import {Reducer} from 'redux'
import {loginStateInterface, CodeActionTypes} from './types'

export const initialState: loginStateInterface = {
    access_token: "",
    loading:false
}

const reducer: Reducer<loginStateInterface> = (state = initialState, action) => {
    switch (action.type) {
        case CodeActionTypes.FETCH_LOGIN: {
            return {...state, loading: true}
        }
        case CodeActionTypes.SET_LOGIN: {
            return {...state, loading: false, ...action.payload}
        }
        case CodeActionTypes.FETCH_ERROR: {
            return {...state, loading: false , access_token: ''}
        }
        default:
            return state
    }
}

export {reducer as loginReducer}